import '../../monitoring/filters/date/date_filter_view.js.coffee'

Namespace 'Surveys.Views.Filters'

class Surveys.Views.Filters.SurveySentAtDateFilterView extends Monitoring.Views.SocialContents.Filters.DateFilterView

  fields:
    date_from_realtime: 'survey_sent_at_from_realtime'
    date_from: 'survey_sent_at_from'
    date_from_ISO: 'survey_sent_at_from_ISO'
    date_to: 'survey_sent_at_to'
    date_to_ISO: 'survey_sent_at_to_ISO'
    date_now: 'survey_sent_at_now'

  initialize: ({searchQuery, title, filtersContainer}) ->
    super(searchQuery: searchQuery, filtersContainer: filtersContainer)
    @title = title || I18n.t('surveys.dashboard.filters.sent_at')

  prefix: ->
    'survey_sent_at'

  _minDate: ->
    @_oldContentAwareMinDate()
